/* eslint-disable react/jsx-props-no-spreading */
import { FC, ReactElement, useCallback, useEffect, useState } from 'react';
import { Icons } from '~/assets/fonts/Icons/icons';
import { DEBOUNCE_TIME } from '~/constants/main';
import theme from '~/constants/styles';
import { localeStore } from '~/mobx/localesStore';
import { debounce } from '~/utils/perfomance';
import Icon from '~/view/components/Controls/Icon/Icon';
import Input from '~/view/components/Controls/InputComponent/Input';
import { IInputProps } from '~/view/components/Controls/InputComponent/types';

export interface ISearchInputProps extends IInputProps {
  hideSearchIcon?: boolean;
  debounceDelay?: number;
}

const SearchInput: FC<ISearchInputProps> = ({
  value,
  defaultValue,
  onChangeValue,
  resetIcon = true,
  hideSearchIcon,
  debounceDelay = DEBOUNCE_TIME.LARGE,
  // eslint-disable-next-line unused-imports/no-unused-vars
  prevComponent,
  placeholder = 'txt_search',
  ...props
}: ISearchInputProps): ReactElement => {
  const [searchValue, setSearchValue] = useState<string | undefined>(String(value || defaultValue || ''));

  useEffect(() => {
    setSearchValue(String(value || ''));
  }, [value]);

  const onChangeValueWithDelay = debounce(onChangeValue, debounceDelay);
  const onChangeValueWithoutDelay = onChangeValue;

  const onSearch = useCallback(
    (value: string | undefined) => {
      setSearchValue(value);

      if (debounceDelay) {
        onChangeValueWithDelay(value);
        return;
      }

      onChangeValueWithoutDelay(value);
    },
    [debounceDelay]
  );

  return (
    <Input
      {...props}
      value={searchValue}
      onChangeValue={onSearch}
      placeholder={localeStore.t(placeholder)}
      resetIcon={resetIcon}
      prevComponent={hideSearchIcon ? undefined : <Icon name={Icons.Search} size={16} color={theme.colors.gray2} className="ml-3" />}
    />
  );
};

export default SearchInput;
